module.exports = __webpack_public_path__ + "static/media/registerM.dcf578c7.jpg";